/** Alinhado ao backend de Project: Lucide kebab-case, máx. 64 chars, default "folder". */
const LUCIDE_ICON_KEY_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Valor a enviar no POST/PUT de Project. Retorna null quando o usuário não escolheu
 * ícone — o backend aplica default "folder" automaticamente quando o campo é omitido.
 */
export function projectIconKeyToApi(ui: string | null | undefined): string | null {
  const trimmed = (ui ?? '').trim();
  if (!trimmed) return null;

  const lower = trimmed.toLowerCase();
  const normalized = lower.replace(/[_\s]+/g, '-').replace(/[^a-z0-9-]/g, '');

  if (
    normalized.length > 0 &&
    normalized.length <= 64 &&
    LUCIDE_ICON_KEY_PATTERN.test(normalized)
  ) {
    return normalized;
  }

  return null;
}
